// Constants
import { EMBED, TWEET, COPY_URL_LINK, SHARE } from 'NewAngular/constants/core.constants';
// Types / Interfaces / Enums
import { NameInLegendOption } from 'ChartApp/ts/enums/chart-common.enum';
import { ScatterPlotChartSize } from 'ChartApp/ts/enums/scatter-plot-common.enum';
const SAVED_SCATTER_PLOT_SHARING_OPTIONS = {
    title: {
        label: 'Share',
        icon: 'icon-share',
    },
    list: [
        {
            type: 'option',
            label: 'Share with Team',
            value: SHARE,
            icon: 'icon-team',
        },
        {
            type: 'divider',
            label: null,
            value: null,
            icon: null,
        },
        {
            type: 'option',
            label: 'Tweet',
            value: TWEET,
            icon: 'icon-tweet',
        },
        {
            type: 'option',
            label: 'Embed Code',
            value: EMBED,
            icon: 'icon-embed',
        },
        {
            type: 'option',
            label: 'Copy Link',
            value: COPY_URL_LINK,
            icon: 'icon-link',
        },
    ],
};
// Scatter plot parameters whose changed values do not require a request to the backend for new data
// for interactive charts.
const SCATTER_PLOT_INTERACTIVE_PARAMS_NO_NEW_DATA = ['chartType', 'axisExtremes', 'displayLegendOnChart'];
const SCATTER_PLOT_MAX_SECURITIES = 20;
// Scatter Plot Size Options
const PARTNER_OPTION_DEFAULT = ScatterPlotChartSize.basic_2000;
const PARTNER_OPTIONS = [
    {
        label: 'Small (650 px wide)',
        value: ScatterPlotChartSize.basic_650,
    },
    {
        label: 'Medium (850 px wide)',
        value: ScatterPlotChartSize.basic_850,
    },
    {
        label: 'Large (1200 px wide)',
        value: ScatterPlotChartSize.basic_1200,
    },
    {
        label: 'Very Large (2000 px wide)',
        value: ScatterPlotChartSize.basic_2000,
    },
];
const NAME_IN_LEGEND_DEFAULT = NameInLegendOption.nameAndTicker;
export { SAVED_SCATTER_PLOT_SHARING_OPTIONS, SCATTER_PLOT_MAX_SECURITIES, SCATTER_PLOT_INTERACTIVE_PARAMS_NO_NEW_DATA, PARTNER_OPTIONS, PARTNER_OPTION_DEFAULT, NAME_IN_LEGEND_DEFAULT, };
// sharing urls
export const SCATTER_PLOT_SHARING_URL_OPTIONS = {
    TWITTER: {
        url: '/charts/share_twitter/auth/scatterplot/',
        width: 720,
        height: 780,
    },
};
import { FolderableAppType } from 'FoldersApp/enums/folderable-app-type.enum';
export const SCATTER_PLOT_FOLDERABLE_APP_CONFIG = {
    appName: 'ScatterPlotApp',
    folderableAppType: FolderableAppType.MODAL,
    itemNamePlural: 'Scatter Plots',
};
